import { useQuery } from "hooks/useQuery";
import { getPortfolioOverview } from "features/Dashboard/service";

export const usePortfolioOverview = (portfolioId, enabled) => {
  const { isLoading, data, refetch } = useQuery({
    key: "portfolioOverview",
    queryKey: ["portfolioOverview", portfolioId],
    queryFn: async () => {
      const response = await getPortfolioOverview(portfolioId);
      return response;
    },
    enabled,
  });

  return {
    isLoading,
    data,
    refetch,
  };
};
